module.exports = __webpack_public_path__ + "img/หมึกกระดอง.641a8fed.jpeg";